import React, { Component } from "react";

import Info from "./Info";
import List from "./List";
import Tabs from "./Tabs";
import Tree from "./Tree";
import Left from "./Left";
import Right from "./Right";
import Top from "./Top";
import Bottom from "./Bottom";
import Footer from "./Footer";
import ButtonBar from "./ButtonBar";

import "./index.less";

class Panel extends Component {

  state = {
    maxWidth: "auto",
  };

  __divRef = null;
  __refreshTimeId = null;
  __resizeObserver = null;

  componentWillUnmount() {
    if (this.__resizeObserver) {
      this.__resizeObserver.disconnect();
      this.__resizeObserver = null;
    }
  }

  onDivRef = (e) => {
    if (e) {
      this.__divRef = e;
      this.__refreshWidth(333);
      this.__initResizeObserver();
    };
  }

  __refreshWidth = (ms = 0) => {
    if (this.__refreshTimeId) {
      clearTimeout(this.__refreshTimeId);
      this.__refreshTimeId = null;
    }
    if (0 === ms) {
      this.__refreshWidthHandle();
    } else {
      this.__refreshTimeId = setTimeout(this.__refreshWidthHandle, ms);
    }
  };

  __refreshWidthHandle = () => {
    let maxWidth = 0;
    const parentEle = this.__divRef.parentElement;
    if (parentEle) {
      maxWidth = parentEle.offsetWidth;
    }
    if (maxWidth !== this.state.maxWidth) {
      this.setState({
        ...this.state,
        maxWidth,
      });
    }
  };

  __initResizeObserver = () => {
    this.__resizeObserver = new ResizeObserver(() => {
      this.__refreshWidth(0);
    });
    this.__resizeObserver.observe(this.__divRef.parentElement);
  };

  render() {
    const style = {
      ...this.props.style,
      maxWidth: this.state.maxWidth,
    };
    return (
      <div
        className={"nano-panel " + (this.props.className || "")}
        ref={this.onDivRef}
        style={style}
      >
        {this.props.children}
      </div>
    );
  };
}

Panel.Info = Info;

Panel.List = List;

Panel.Tabs = Tabs;

Panel.Tree = Tree;

Panel.Left = Left;

Panel.Right = Right;

Panel.Top = Top;

Panel.Bottom = Bottom;

Panel.Footer = Footer;

Panel.Footer.ButtonBar = ButtonBar;

export default Panel;
